import _sortBy from 'lodash/sortBy';

function Ctrl($scope, $stateParams, $timeout, $uibModalInstance, jsSdkUser, jsSdkCity, loggerService) {
  $scope.errorMsg = '';
  $scope.successMsg = '';
  $scope.loading = true;

  const user = jsSdkUser.getCurrentUser();

  $scope.selectedCityId = (user && user.location && user.location.preferred && user.location.preferred.id) ? user.location.preferred.id : null;

  jsSdkCity.list()
    .then(resp => {

      $scope.loading = false;

      $scope.cities = _sortBy(resp, function(city) {
        return city.id !== $scope.selectedCityId;
      });
    })
    .catch(resp => {
      loggerService.error(resp);

      $scope.errorMsg = 'Unable to load city list';
    });

  $scope.setCity = function(cityId) {
    $scope.errorMsg = null;
    $scope.successMsg = null;

    if (!cityId) {
      $scope.errorMsg = 'Please select a city.';
      return;
    }

    jsSdkUser.updatePreferredCity(cityId)
      .then(() => {
        return jsSdkUser.me();
      })
      .then(() => {
        $scope.loading = false;
        $scope.successMsg = 'Default city updated.';
      })
      .catch(resp => {
        loggerService.error(resp);

        $scope.loading = false;
        $scope.errorMsg = 'Unable to change preferred city.';
      });
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };
}

Ctrl.$inject = [
  '$scope',
  '$stateParams',
  '$timeout',
  '$uibModalInstance',
  'jsSdk.user',
  'jsSdk.city',
  'loggerService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/services/modal/editCities/editCitiesModalCtrl.js